import type { IQuery } from "@citrine/client";
import ClientBase from "@citrine/client";

import type { PredictorQuery } from "../predictor/predictor-client";
import { PredictorClient } from "../predictor/predictor-client";
import type { PredictorSummary } from "../predictor-summary";

export class PredictorSummaryVersionClient extends ClientBase<
  PredictorSummary,
  string,
  PredictorQuery
> {
  create!: never;
  useCreate!: never;
  delete!: never;
  useDelete!: never;
  patch!: never;
  usePatch!: never;
  update!: never;
  useUpdate!: never;

  protected constructor(
    protected readonly projectId: string,
    protected readonly predictorId: string,
  ) {
    super({
      endpoint: `/api/v3/projects/${projectId}/predictor-summaries/${predictorId}/versions`,
      findField: "response",
      defaultQuery: {
        page: 1,
        per_page: 20,
        name: undefined,
        archived: undefined,
        sort_by: undefined,
        dataSource: undefined,
        branch: undefined,
      },
      idField: "metadata.version",
    });
  }

  static getInstance(projectId: string, predictorId: string) {
    return new PredictorSummaryVersionClient(projectId, predictorId);
  }

  protected normalizeQuery(query: PredictorQuery = {}): IQuery {
    return PredictorClient.prototype.normalizeQuery.call(this, query);
  }
}
